import { cn } from '@/utils/cn'

type AmbientVariant = 'shell' | 'page' | 'quiet'

interface AmbientLayerProps {
  variant?: AmbientVariant
  className?: string
}

/**
 * L0 atmosphere — aurora mesh + bloom + drift, plus optional sparse texture
 * (micro flow lines + outline bubbles) on outer shell only. CSS-only motion.
 */
export function AmbientLayer({ variant = 'shell', className }: AmbientLayerProps) {
  const isPageStage =
    variant === 'page' || Boolean(className?.includes('ambient-layer--page-quiet'))
  const showTexture = !isPageStage && (variant === 'shell' || variant === 'quiet')

  return (
    <div
      className={cn('ambient-layer', `ambient-layer--${variant}`, className)}
      aria-hidden
    >
      <span className="aurora-mesh" />
      <span className="aurora-bloom" />
      <span className="aurora-drift" />
      {showTexture ? (
        <span className="ambient-texture">
          <svg
            className="ambient-flow-lines"
            viewBox="0 0 1200 800"
            preserveAspectRatio="none"
            aria-hidden
          >
            <path
              className="ambient-flow ambient-flow--1"
              d="M-40 190 C 160 50, 340 310, 540 150 S 840 70, 1000 230 S 1180 360, 1240 290"
            />
            <path
              className="ambient-flow ambient-flow--2"
              d="M-30 540 C 170 620, 390 450, 580 570 S 900 690, 1060 510 S 1220 430, 1260 490"
            />
            <path
              className="ambient-flow ambient-flow--3"
              d="M 60 -30 C 220 140, 130 300, 380 360 S 660 270, 760 440 S 940 640, 1140 560"
            />
            <path
              className="ambient-flow ambient-flow--4"
              d="M 1120 80 C 980 210, 1080 370, 860 430 S 600 360, 520 540"
            />
          </svg>
          <span className="ambient-outline ambient-outline--1" />
          <span className="ambient-outline ambient-outline--2" />
          <span className="ambient-outline ambient-outline--3" />
          <span className="ambient-outline ambient-outline--4" />
          <span className="ambient-outline ambient-outline--5" />
        </span>
      ) : null}
    </div>
  )
}
